import { usePremadeQuizzes } from '@quizzach/api-hooks';
import { Navigation, QuizGrid, ShareButton } from '@quizzach/components';
import { RoutePath } from '@quizzach/interfaces';
import { Reveal } from '@quizzach/motion';
import {
	BtnLine,
	MoreStrip,
	PhHead,
	PremadePage,
	TagBar,
} from '@quizzach/styles';
import { scrollToTop, sortByCreatedAt } from '@quizzach/utils';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

export const PremadeQuizzesByTag = () => {
	const { t } = useTranslation();
	const { tag } = useParams();
	const { premadeQuizzes, loading, error, getPremadeQuizzes } =
		usePremadeQuizzes();

	const shareData = {
		text: t('premade.byTag.shareText', { tag: tag ?? '' }),
		url: `https://quizzach.com/premade/tag/${encodeURIComponent(tag ?? '')}`,
	};

	useEffect(() => {
		scrollToTop();
		if (tag) {
			getPremadeQuizzes({ tag: tag });
		}
	}, []);

	return (
		<PremadePage>
			<Navigation />

			<PhHead>
				<Reveal as='h1'>
					{t('premade.byTag.title')}
					<br />
					<em>{tag}</em>
				</Reveal>
				<Reveal className='side' delay={1}>
					<ShareButton shareData={shareData} popoverPlacement='down' />
				</Reveal>
			</PhHead>

			<Reveal>
				<TagBar>
					<Link to={RoutePath.PremadeQuizzes}>
						{t('premade.redesign.allTag')}
					</Link>
					<a className='on'>{tag}</a>
				</TagBar>
			</Reveal>

			<QuizGrid
				quizzes={premadeQuizzes?.sort(sortByCreatedAt)}
				loading={loading}
				error={error}
			/>

			<MoreStrip>
				<BtnLine
					as={Link}
					to={RoutePath.PremadeQuizzes + '/' + RoutePath.PremadeSearch}
				>
					{t('premade.byTag.searchMore')}
				</BtnLine>
			</MoreStrip>
		</PremadePage>
	);
};
